export const NOTIFICATION_STATUS_PENDING = 1;
export const NOTIFICATION_STATUS_SUCCESS = 2;
export const NOTIFICATION_STATUS_FAILED = 3;
export const NOTIFICATION_STATUS_DISABLED = 4;
export const NOTIFICATION_STATUS_SENDING = 5;
export const NOTIFICATION_STATUS_RETRYING = 6;

export const SMSSendingResourceName = "SMS sending";
export const NotificationResourceName = 'Notification';
export const PopupNotificationResourceName = 'Pop-up Notification';

export const NOTIFICATION_STATUS_NAME = {
  [NOTIFICATION_STATUS_PENDING]: 'Pending',
  [NOTIFICATION_STATUS_SUCCESS]: 'Sent',
  [NOTIFICATION_STATUS_FAILED]: 'Failed',
  [NOTIFICATION_STATUS_DISABLED]: 'Disabled',
  [NOTIFICATION_STATUS_SENDING]: 'Sending',
  [NOTIFICATION_STATUS_RETRYING]: 'Retrying',
};


export const NOTIFICATION_STATUS_DISPLAY_CHOICES = [
  { id: '', name: ''},
  { id: NOTIFICATION_STATUS_PENDING, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_PENDING] },
  { id: NOTIFICATION_STATUS_SUCCESS, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_SUCCESS] },
  { id: NOTIFICATION_STATUS_FAILED, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_FAILED] },
  { id: NOTIFICATION_STATUS_DISABLED, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_DISABLED] },
  { id: NOTIFICATION_STATUS_SENDING, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_SENDING] },
  { id: NOTIFICATION_STATUS_RETRYING, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_RETRYING] },
];

export const NOTIFICATION_STATUS_EDIT_CHOICES = [
  { id: NOTIFICATION_STATUS_PENDING, name: 'Enabled' },
  { id: NOTIFICATION_STATUS_DISABLED, name: NOTIFICATION_STATUS_NAME[NOTIFICATION_STATUS_DISABLED] },
];

export const NOTIFICATION_DELIVER_NOW = 1;
export const NOTIFICATION_DELIVER_LATER = 2;

export const NOTIFICATION_DELIVER_TYPE_NAME = {
  [NOTIFICATION_DELIVER_NOW]: 'Deliver Now',
  [NOTIFICATION_DELIVER_LATER]: 'Deliver Later',
};

export const NOTIFICATION_DELIVER_TYPE_CHOICES = [
  { id: NOTIFICATION_DELIVER_NOW, name: NOTIFICATION_DELIVER_TYPE_NAME[NOTIFICATION_DELIVER_NOW] },
  { id: NOTIFICATION_DELIVER_LATER, name: NOTIFICATION_DELIVER_TYPE_NAME[NOTIFICATION_DELIVER_LATER] },
];

export const MESSAGE_TYPE_TEXT = 1;
export const MESSAGE_TYPE_ARTICLE = 2;

export const MESSAGE_TYPE_NAME = {
  [MESSAGE_TYPE_TEXT]: 'Text',
  [MESSAGE_TYPE_ARTICLE]: 'Article',
};

export const MESSAGE_TYPE_CHOICES = [
  { id: MESSAGE_TYPE_TEXT, name: MESSAGE_TYPE_NAME[MESSAGE_TYPE_TEXT] },
  { id: MESSAGE_TYPE_ARTICLE, name: MESSAGE_TYPE_NAME[MESSAGE_TYPE_ARTICLE] },
];

export const MESSAGE_SEND_ALL = 1;
export const MESSAGE_SEND_SPECIFIC_USERS = 2;

export const SEND_TYPE_NAME = {
  [MESSAGE_SEND_ALL]: 'All',
  [MESSAGE_SEND_SPECIFIC_USERS]: 'Selected User',
};

export const SEND_TYPE_CHOICES = [
  { id: MESSAGE_SEND_ALL, name: SEND_TYPE_NAME[MESSAGE_SEND_ALL] },
  { id: MESSAGE_SEND_SPECIFIC_USERS, name: SEND_TYPE_NAME[MESSAGE_SEND_SPECIFIC_USERS] },
];

export const APP_TYPE_ALL = 1;
export const APP_TYPE_OCHA_MANAGER = 2;
export const APP_TYPE_OCHA_POS = 3;

export const APP_TYPE_NAME = {
  [APP_TYPE_ALL]: 'All',
  [APP_TYPE_OCHA_POS]: 'Ocha POS',
  [APP_TYPE_OCHA_MANAGER]: 'Ocha Manager',
};

export const APP_TYPE_CHOICES = [
  { id: APP_TYPE_ALL, name: APP_TYPE_NAME[APP_TYPE_ALL] },
  { id: APP_TYPE_OCHA_POS, name: APP_TYPE_NAME[APP_TYPE_OCHA_POS] },
  { id: APP_TYPE_OCHA_MANAGER, name: APP_TYPE_NAME[APP_TYPE_OCHA_MANAGER] },
];

export const POPUP_NOTIFICATION_TERM_CONDITIONS = 1;
export const POPUP_NOTIFICATION_PRIVACY_POLICY = 2;
export const POPUP_NOTIFICATION_OTHERS = 3;

export const POPUP_NOTIFICATION_TYPE_NAME = {
  [POPUP_NOTIFICATION_TERM_CONDITIONS]: 'Terms & Conditions',
  [POPUP_NOTIFICATION_PRIVACY_POLICY]: 'Privacy Policy',
  [POPUP_NOTIFICATION_OTHERS]: 'Others'
}

export const POPUP_NOTIFICATION_TYPE_CHOICES = [
  { id: '', name: ''},
  { id: POPUP_NOTIFICATION_TERM_CONDITIONS, name: POPUP_NOTIFICATION_TYPE_NAME[POPUP_NOTIFICATION_TERM_CONDITIONS] },
  { id: POPUP_NOTIFICATION_PRIVACY_POLICY, name: POPUP_NOTIFICATION_TYPE_NAME[POPUP_NOTIFICATION_PRIVACY_POLICY] },
  { id: POPUP_NOTIFICATION_OTHERS, name: POPUP_NOTIFICATION_TYPE_NAME[POPUP_NOTIFICATION_OTHERS] }
]

export const POPUP_NOTIFICATION_STATUS_PENDING = 1;
export const POPUP_NOTIFCATION_PUBLISHED = 2;

export const POPUP_NOTIFICATION_STATUS_NAME = {
  [POPUP_NOTIFICATION_STATUS_PENDING]: 'Pending',
  [POPUP_NOTIFCATION_PUBLISHED]: 'Published',
};

export const POPUP_NOTIFICATION_STATUS_DISPLAY_CHOICES = [
  { id: '', name: ''},
  { id: POPUP_NOTIFICATION_STATUS_PENDING, name: POPUP_NOTIFICATION_STATUS_NAME[POPUP_NOTIFICATION_STATUS_PENDING] },
  { id: POPUP_NOTIFCATION_PUBLISHED, name: POPUP_NOTIFICATION_STATUS_NAME[POPUP_NOTIFCATION_PUBLISHED] }
]

export const POPUP_STATUS_DISPLAY_CHOICES = [
  { enabled: true, name: 'enabled' },
  { enabled: false, name: 'disabled' }
]


// WEBPACK FOOTER //
// ./src/routes/notification/utils.js